import { ACTIONS, MUTATIONS, STATE } from '../../../storeConstants';
import { buildPaymentData } from '../../../util/formula';

function clickSnapPosition(state, getters) {
  if (state.base.CHART_CLICK_INDEX <= 0) return 0;
  if (
    state.base.CHART_CLICK_INDEX * state.base.INTERVAL
    > getters.MODIFIED_TERM - 1
  ) return (state.base.CHART_CLICK_INDEX - 1) * state.base.INTERVAL;
  return state.base.CHART_CLICK_INDEX * state.base.INTERVAL;
}

function resetChart(commit, getters, CHANGE, state) {
  commit(CHANGE, {
    target: 'CHART_CLICK_INDEX',
    value: Math.round((state.base.CHART_SELECTOR_PERCENTAGE_X
      * getters.MODIFIED_TERM) / state.base.INTERVAL),

  });
  commit(CHANGE, {
    target: 'CHART_SELECTOR_SNAP_X',
    value: Math.round(clickSnapPosition(state, getters)),
  });
  const newPointRadius = new Array(
    Math.ceil(getters.INTERVAL_LENGTH_MONTHS),
  ).fill(0);
  newPointRadius[state.base.CHART_CLICK_INDEX] = 5;
  commit(CHANGE, {
    target: 'POINT_RADIUS',
    value: [...newPointRadius],
  });
}

function updatePaymentData(commit, getters, state, CHANGE, PAYMENT_DATA) {
  const newPaymentData = buildPaymentData({
    ...state.base, PAYMENT: getters.PAYMENT, MODIFIED_TERM: getters.MODIFIED_TERM,
  });

  commit(CHANGE, { target: PAYMENT_DATA, value: newPaymentData });
  commit(CHANGE, { target: 'MODIFY_TERM', value: state.base.TERM - newPaymentData.length })
  resetChart(commit, getters, CHANGE, state);
}

export default {
  //split out so that they only triggered by specifc changes, not by side effects.  
  [ACTIONS.UPDATE_ANNUAL_PAYMENT_AMOUNT]: {
    action: {
      before: {
        method({ commit }, payload) {
          commit(MUTATIONS.CHANGE, payload);
        },
      },
      after: {
        method({ commit, getters }, payload, state) {
          updatePaymentData(commit, getters, state, MUTATIONS.CHANGE, STATE.PAYMENT_DATA, payload.value);
        },
      },
    },
  },
  [ACTIONS.UPDATE_DOWNPAYMENT]: {
    action: {
      before: {
        method({ commit }, payload) {
          commit(MUTATIONS.CHANGE, payload);
        },
      },
      after: {
        method({ commit, getters }, payload, state) {
          updatePaymentData(commit, getters, state, MUTATIONS.CHANGE, STATE.PAYMENT_DATA, payload.value);
        },
      },
    },
  },
  [ACTIONS.UPDATE_MORTGAGE_START_DATE]: {
    action: {
      before: {
        method({ commit }, payload) {
          commit(MUTATIONS.CHANGE, payload);
        },
      },
      after: {
        method({ commit, getters }, payload, state) {
          updatePaymentData(commit, getters, state, MUTATIONS.CHANGE, STATE.PAYMENT_DATA, payload.value);
        },
      },
    },
  },
  [ACTIONS.UPDATE_EXTRA_MONTHLY_PAYMENT_AMOUNT]: {
    action: {
      before: {
        method({ commit }, payload) {
          commit(MUTATIONS.CHANGE, payload);
        },
      },
      after: {
        method({ commit, getters }, payload, state) {
          updatePaymentData(commit, getters, state, MUTATIONS.CHANGE, STATE.PAYMENT_DATA, payload.value);
        },
      },
    },
  },
  [ACTIONS.UPDATE_ONE_TIME_PAYMENT_AMOUNT]: {
    action: {
      before: {
        method({ commit }, payload) {
          commit(MUTATIONS.CHANGE, payload);
        },
      },
      after: {
        method({ commit, getters }, payload, state) {
          updatePaymentData(commit, getters, state, MUTATIONS.CHANGE, STATE.PAYMENT_DATA, payload.value);
        },
      },
    },
  },

  [ACTIONS.UPDATE_ANNUAL_PAYMENT_DATE]: {
    action: {
      before: {
        method({ commit }, payload) {
          commit(MUTATIONS.CHANGE, payload);
        },
      },
      after: {
        method({ commit, getters }, payload, state) {
          updatePaymentData(commit, getters, state, MUTATIONS.CHANGE, STATE.PAYMENT_DATA, payload.value);
        },
      },
    },
  },
  [ACTIONS.UPDATE_INTEREST_RATE]: {
    action: {
      before: {
        method({ commit }, payload) {
          commit(MUTATIONS.CHANGE, payload);
        },
      },
      after: {
        method({ commit, getters }, payload, state) {
          updatePaymentData(commit, getters, state, MUTATIONS.CHANGE, STATE.PAYMENT_DATA, payload.value);
        },
      },
    },
  },

  [ACTIONS.UPDATE_ONE_TIME_PAYMENT_DATE]: {
    action: {
      before: {
        method({ commit }, payload) {
          commit(MUTATIONS.CHANGE, payload);
        },
      },
      after: {
        method({ commit, getters }, payload, state) {
          updatePaymentData(commit, getters, state, MUTATIONS.CHANGE, STATE.PAYMENT_DATA, payload.value);
        },
      },
    },

  },

  [ACTIONS.UPDATE_PRINCIPLE]: {
    action: {
      before: {
        method({ commit }) {
          commit(MUTATIONS.CHANGE, { target: STATE.MODIFY_TERM, value: 0 });
        },
      },
      after: {
        method({ commit, getters }, payload, state) {
          updatePaymentData(commit, getters, state, MUTATIONS.CHANGE, STATE.PAYMENT_DATA, payload.value);
        },
      },
    },
  },

  [ACTIONS.UPDATE_TERM]: {
    action: {
      before: {
        method({ commit }) {
          commit(MUTATIONS.CHANGE, { target: STATE.MODIFY_TERM, value: 0 });
        },
      },
      after: {
        method({ commit, getters }, payload, state) {
          let modState = { ...state.base };
          modState.PAYMENT_DATA = { length: payload.value };
          state.base = modState;
          updatePaymentData(commit, getters, state, MUTATIONS.CHANGE, STATE.PAYMENT_DATA, payload.value);
          commit(MUTATIONS.CHANGE, { target: STATE.ONE_TIME_PAYMENT_AMOUNT, value: 0 });
          commit(MUTATIONS.CHANGE, { target: STATE.ANNUAL_PAYMENT_AMOUNT, value: 0 });
          commit(MUTATIONS.CHANGE, { target: STATE.EXTRA_MONTHLY_PAYMENT_AMOUNT, value: 0 });
          commit(MUTATIONS.CHANGE, { target: STATE.MODIFY_TERM, value: 0 });


        },
      },
    },
  },

};
